/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'go to': {
    width: 16,
    height: 16,
    viewBox: '0 0 46.1 46',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M18.27 6.49H7.79A10.21 10.21 0 0 0 6 6.65a6.86 6.86 0 0 0-3.62 2 7.15 7.15 0 0 0-1.89 5v24.72a10.74 10.74 0 0 0 .13 1.43 6.58 6.58 0 0 0 .69 2 6.66 6.66 0 0 0 1.23 1.67 7.07 7.07 0 0 0 5.06 2h24.75a7.11 7.11 0 0 0 .75 0 8.58 8.58 0 0 0 1.29-.21 8.36 8.36 0 0 0 1.26-.49 6.63 6.63 0 0 0 1.7-1.18 6.72 6.72 0 0 0 2-3.59 9.34 9.34 0 0 0 .16-1.76V27.66"/><path pid="1" class="cls-2" d="M26 .5h19.6v19.37M19.37 26.37L45.6.5"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/go to.js